<template>
	<div id="app">
		<img alt="" src="./assets/index.png">
		<div class="link">
			<div class="ul">
				<a href="http://smartwaters.cn:8083/" target="_blank" rel="noopener"></a>
				<a href="javascript:;" @click.prevent="showTip" target="_blank" rel="noopener"></a>
				<a href="http://wushuichang.smartwaters.cn/" target="_blank" rel="noopener"></a>
				<a href="http://smartwaters.cn:8081/" target="_blank" rel="noopener"></a>
				<a href="http://smartwaters.cn:8090/" target="_blank" rel="noopener"></a>
				<a href="javascript:;" @click.prevent="showTip" target="_blank" rel="noopener"></a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		// 提示方法
		showTip() {
			alert("该功能暂未开放，敬请期待！");
		}
	}
}
</script>

<style>
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	body {
		margin: 0;
		padding: 0;
	}

	#app {
		width: 100vw;
		height: 100vh;
		overflow: hidden;
		position: relative;
		box-sizing: border-box;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.link {
		width: 100%;
		position: absolute;
		z-index: 1;
		top: 0;
	}

	.ul {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between;
		width: 84%;
		/* height: 80%; */
		margin: 22.5vh 8% 0;
	}

	a {
		cursor: pointer;
		width: 27%;
		/* background-color: rgba(0, 0, 0, 0.2); */
		height: 25vh;
		line-height: 12vh;
		text-align: center;
		margin-bottom: 18vh;
	}
</style>